import { useEffect, useState } from 'react'
import TopNav from '../../components/topNavbar/leftNav/topNav'
import LeftNav from '../../components/leftNav/leftNav'
import Explorer from '../../components/explorer/explorer'
import Footer from '../../components/footer/footer'
import Home from '../home/home'
import Projects from '../projects/projects'
import Me from '../me/me'
import Tapbar from '../../components/tapbar/tapbar'
import Contact from '../contact/contact'
import Error from '../error/error'
import UnderConstruction from '../underConstruction/underConstruction'
import Impressum from '../impressum/impressum'
import Gallery from '../gallery/gallery'
import Readme from '../readme/readme'

import { Route, Routes, useLocation } from 'react-router-dom'
import { useCookies } from 'react-cookie'
import { appConfig } from '../../config'
import { useTranslation } from 'react-i18next'
import StructuredData from '../../components/seo/StructuredData'

import './app.scss'

const underConstruction = false

function App() {
  const isMobile = window.innerWidth <= 600
  const [explorerSize, setExplorerSize] = useState(200)
  const [footerSize, setFooterSize] = useState(isMobile ? 60 : 200)
  const [cookies] = useCookies(['themen'])
  const [contactForm, setContactForm] = useState({
    name: '',
    mail: '',
    text: ''
  })
  const { i18n } = useTranslation()

  const location = useLocation()

  const [openTabs, setOpenTabs] = useState(() => {
    const findConfig = appConfig.find(obj => obj.path === location.pathname )
    return [{ path: location.pathname, title: findConfig?.title ?? 'error'  }]
  })

  useEffect(() => {
    if(cookies.themen) {
      document.getElementById('theme')?.classList.add(cookies.themen)
    }
  }, [cookies.themen])

  // Update lang attribute dynamically based on i18n language
  useEffect(() => {
    const htmlElement = document.documentElement
    htmlElement.lang = i18n.language
  }, [i18n.language])

  // Update canonical URL based on current route
  useEffect(() => {
    const baseUrl = 'https://dwain.info'
    const canonicalUrl = `${baseUrl}${location.pathname}`

    let linkElement = document.querySelector('link[rel="canonical"]')
    if (!linkElement) {
      linkElement = document.createElement('link')
      linkElement.setAttribute('rel', 'canonical')
      document.head.appendChild(linkElement)
    }
    linkElement.setAttribute('href', canonicalUrl)
  }, [location.pathname])

  useEffect(() => {
    const newOpenTabs =[...openTabs]
    const findConfig = appConfig.find(obj => obj.path === location.pathname )

    if(!newOpenTabs.find(tab => tab.path === location.pathname)) {
      newOpenTabs.push({ path: location.pathname, title: findConfig?.title ?? 'error' })
      setOpenTabs(newOpenTabs)
    }
  }, [location.pathname, openTabs])

  if(underConstruction)  {
    return (
      <UnderConstruction />
    )
  }

  return (
    <div className='app'>
      <StructuredData type={location.pathname === '/contact' ? 'contactpage' : 'person'} />
      <TopNav explorerSize={explorerSize} setExplorerSize={setExplorerSize} footerSize={footerSize} setFooterSize={setFooterSize} />

      <div className='app-content' style={{ gridTemplateColumns: `60px ${explorerSize}px 1fr` }}>
        <LeftNav />
        <Explorer explorerSize={explorerSize} setExplorerSize={setExplorerSize} />

        <div className='content-footer' style={{ gridTemplateRows: `44px 1fr ${footerSize}px` }}>
          <Tapbar openTabs={openTabs} setOpenTabs={setOpenTabs}/>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/projects' element={<Projects />} />
            <Route path='/gallery' element={<Gallery />} />
            <Route path='/contact' element={<Contact contactForm={contactForm} setContactForm={setContactForm}/>} />
            <Route path='/aboutme' element={<Me />} />
            <Route path='/impressum' element={<Impressum />} />
            <Route path='/readme' element={<Readme />} />
            <Route path='*' element={<Error />} />
          </Routes>
          <Footer
            footerSize={footerSize}
            setFooterSize={setFooterSize}
          />
        </div>
      </div>
    </div>
  )
}

export default App
